module.exports = __webpack_public_path__ + "static/assets/84ad46536cb4de7a9e82347461b375a1.svg";